import { useRef } from "react";
import { useTellescopeSessionQuery } from "../use-tellescope-session-query";
import { useApplyCacheUpdatesFromDataSync } from "../internal-hooks";
import { SessionMethodParams, SessionMethodReturn } from "../../types";

export interface UseDataSyncPollArgs {
  pollingRateInMs: number;
  enabled?: boolean;
  refetchInBackground?: boolean;
  requestSideEffect?: (request: SessionMethodParams<"sync">) => void;
  responseSideEffect?: (request: SessionMethodParams<"sync">, response: SessionMethodReturn<"sync">) => void;
}

export const useDataSyncPoll = ({
  pollingRateInMs,
  enabled = true,
  refetchInBackground = true,
  requestSideEffect,
  responseSideEffect,
}: UseDataSyncPollArgs) => {
  const initialTimestampRef = useRef(new Date());
  const { applyUpdates } = useApplyCacheUpdatesFromDataSync();

  return useTellescopeSessionQuery({
    method: "sync",
    request: {
      from: initialTimestampRef.current,
    },
    enabled: enabled && pollingRateInMs > 0,
    refetchInterval: pollingRateInMs,
    refetchIntervalInBackground: refetchInBackground,
    requestSideEffect: (...args) => {
      initialTimestampRef.current = new Date();
      requestSideEffect?.(...args);
    },
    responseSideEffect: (req, response) => {
      if (response.results.length) {
        applyUpdates({ updates: response.results ?? [] });
      }
      responseSideEffect?.(req, response);
    },
    requestKeysToOmitFromQueryKey: ["from"],
  });
};
